// extracted by mini-css-extract-plugin
export default {"root":"CompoundForm_root__XJV2J","action":"CompoundForm_action__u5uYU","body":"CompoundForm_body__wXzjZ","error":"CompoundForm_error__w8obj"};